<template>
   <div class="score" >
       <img src="./img/score.png" alt="">
   </div>
</template>

<script>
export default {
    name: 'score',
    data() {
        return {
        }
    },
    components: {
    },
    created () {
        if(this.$route.params.scroll){
            window.scrollTo(0,this.$route.params.scroll);
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.score{
    width: 1200px;
    margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/page/score/score.vue